import firebase from './fb'
import store from '@/store'



firebase.auth().onAuthStateChanged((user) => {
    if (user) {
        var setUser = {
            id: user.uid,
            user: user
        };
        store.commit('authfb/SET_USER', setUser)
        

    } else {
        store.commit('authfb/SET_USER', null)

    }
});